import {Subscription} from 'rxjs';
import {Component, OnDestroy} from '@angular/core';
import {LocalStorage} from './storage.class';
import {Settings} from './settings.class';
import {Utils} from './utils.class';
import {environment} from '../environments/environment';
import {Functionalities} from './services/auth/functionalities';
import {Features} from './services/auth/features';
import {Roles} from './services/auth/roles';
import {Routenames} from './classes/route-name.enum';
import {Crumbs} from './classes/crumb.class';


@Component({
    template: '',
})
export class CodaltComponent implements OnDestroy {

    readonly Functionalities = Functionalities;
    readonly Features = Features;
    readonly Roles = Roles;
    readonly Routenames = Routenames;
    Utils = Utils;
    Settings = Settings;
    LocalStorage = LocalStorage;
    environment = environment;
    crumbs: Crumbs;

    protected subscriptions = new Subscription();

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

}
